module.exports = __webpack_public_path__ + "static/media/3.86e24786.mp3";